export default __webpack_public_path__ + "static/media/mainz_light.3b9ca050.png";